export function table(str) {
  let tableData;

  try {
    tableData = JSON.tryParse(str);
    if (tableData?.[0]?.id) {
      delete tableData[0].id;
    }
  } catch (error) {
    console.error("Error parsing JSON:", error);
    throw new Error("Invalid JSON format");
  }

  if (!Array.isArray(tableData) || tableData.length === 0) {
    throw new Error("Input must be a non-empty array");
  }
  const headers = Object.keys(tableData[0]);

  let html = '<table border="1">\n';

  html += "  <thead>\n    <tr>\n";
  headers.forEach((header) => {
    html += `      <th>${header}</th>\n`;
  });
  html += "    </tr>\n  </thead>\n";

  html += "  <tbody>\n";
  tableData.forEach((row) => {
    html += "    <tr>\n";
    headers.forEach((header) => {
      let cell = row[header];

      if (typeof cell === "string") {
        try {
          const parsedCell = JSON.tryParse(cell);
          if (typeof parsedCell === "object" && parsedCell !== null) {
            cell = parsedCell;
          }
        } catch (error) {
          console.error(error);
        }
      }

      if (typeof cell === "object" && cell !== null) {
        if (Array.isArray(cell)) {
          cell = cell.map((item) => item.displayName || item).join(", ");
        } else {
          cell = Object.values(cell).join(", ");
        }
      }

      html += `      <td>${cell}</td>\n`;
    });
    html += "    </tr>\n";
  });
  html += "  </tbody>\n";

  html += "</table>";

  return html;
}
